import { Component, OnInit } from '@angular/core';
import { MappingService } from 'app/core/services/mapping.service';
import { environment } from 'environments/environment';
import { saveAs } from 'file-saver';

@Component({
  selector: 'upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: []
})
export class UploadFileComponent implements OnInit{
  contacts: any = {
    newConacts: [
        {
            icon: 'ri-checkbox-circle-fill',
            name: 'Prospects generation',
        },
        {
            icon: 'ri-checkbox-circle-fill',
            name: 'Outreach',
        },
    ],

    ownContacts: [
        {
            icon: 'ri-close-circle-fill',
            name: 'Prospects generation',
        },
        {
            icon: 'ri-checkbox-circle-fill',
            name: 'Outreach',
        },
    ],
};

  constructor(public mapping: MappingService) {

  }

  ngOnInit(): void {
   
  }

  downloadFile(e) {
    e.stopPropagation();
    let fileURL: any;
    fileURL = '/assets/other/Import_Sample_file.csv';
    saveAs(fileURL, 'PartnerReach-sample-file.csv');
}

}
